import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '../../auth/context';
import { ChatTier, GetChatTiers } from '../api';

/**
 * The AI tiers the composer offers, cheapest first, with locked rungs included.
 *
 * Empty until auth + org context are ready. Cached 60 s — the ladder only
 * changes when an operator edits it in the admin console.
 */
export function useChatTiers(): {
  tiers: ChatTier[];
  /** Only the rungs the org's plan actually includes. */
  unlockedTiers: ChatTier[];
  isLoading: boolean;
} {
  const { state } = useAuthContext();
  const orgId = state.organization?.id ?? null;

  const { data, isLoading } = useQuery<ChatTier[]>({
    queryKey: ['llm', 'chat-tiers', orgId],
    queryFn: async () => {
      const { data } = await GetChatTiers();
      return data;
    },
    staleTime: 60_000,
    enabled: !!orgId,
  });

  const tiers = data ?? [];
  return { tiers, unlockedTiers: tiers.filter((t) => !t.locked), isLoading };
}
